import {
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
  Divider,
  Link,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { baseurl } from "../../config";
import { motion } from "framer-motion";
import headerConstants from "../../data/headerConstant.json";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import { useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";

interface IThemeProps {
  darkMode: boolean;
  toggleDarkMode: Function;
}
const Header = ({ darkMode, toggleDarkMode }: IThemeProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:750px)");
  const tab = useMediaQuery("(max-width:500px)");
  const gradientStyle = {};

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => setAnchorEl(null);

  const handleMenuItemClick = (url: string) => {
    handleMenuClose();
    window.open(url, "_blank");
  };
  return (
    <Stack
      pt={0.5}
      pb={2}
      mb={2}
      sx={{
        mx: "8px !important",
      }}
      //container
      alignItems={"center"}
      //component={Stack}
      direction={"row"}
      // columns={{ xs: 14 }}
      justifyContent={"space-between"}
    >
      <Link href="/" underline="none">
        <Stack height={{ xs: "5rem" }} alignItems={"center"} direction="row">
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 0.3,
            }}
          >
            <img
              style={{ margin: "auto" }}
              src={`${baseurl}${headerConstants?.img_source}`}
              height="100%"
              alt="logo"
            />
          </Box>
          <Stack
            flexDirection={"column"}
            alignItems={"start"}
            sx={{ color: "customColors.clr2", marginLeft: "0.5rem" }}
          >
            <strong
              style={{
                textAlign: "start",
                fontWeight: "bold",
                fontSize: isSmallScreen ? "1.5rem" : "2rem",
              }}
            >
              {headerConstants?.name}
            </strong>
            <span
              style={{
                fontSize: isSmallScreen ? "0.5rem" : "0.8rem",
              }}
            >
              {headerConstants?.description}
            </span>
            <Typography
              variant="body2"
              style={{
                fontFamily: "inherit",
                fontSize: isSmallScreen ? "0.5rem" : "0.8rem",
              }}
            >
              {headerConstants?.number}
            </Typography>
          </Stack>
        </Stack>
      </Link>
      {!tab ? (
        <Stack spacing={1} alignItems={"flex-end"} justifyContent={"flex-end"}>
          <Grid
            item
            container
            alignItems={"center"}
            justifyContent={"flex-end"}
            direction={"column"}
            xs={12}
            spacing={2}
          >
            <Stack
              direction="row"
              spacing={2}
              my={1}
              alignItems={"center"}
              justifyContent={"flex-end"}
              sx={{ width: "100%" }}
            >
              {/* <Link
                href="https://stxavierspune.akronsystems.com/Admission/pONLINEADMISSIONNEW.aspx"
                underline="none"
                color="inherit"
                target="_blank"
                sx={{
                  fontSize: "0.8rem",
                  color: "black",
                  backgroundColor: "#f4ae4a",
                  px: 1,
                  py: 0.5,
                  borderRadius: "4px",
                  ":hover": {
                    backgroundColor: "#f5b356",
                  },
                }}
              >
                Application Form 2025-26
              </Link> */}
              <Box sx={{ display: "inline-block"}}>
                <Link
                  component="button"
                  onClick={handleMenuClick}
                  underline="none"
                  color="inherit"
                  sx={{
                    fontSize: "0.8rem",
                    color: "white",
                    backgroundColor: "#00acd6",
                    px: 1,
                    py: 0.5,
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.3,
                    border: "none",
                    cursor: "pointer",
                    ":hover": {
                      backgroundColor: "#00c0ef",
                    },
                  }}
                >
                  CIRCULARS <KeyboardArrowDown fontSize="small" />
                </Link>

                <Menu
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  PaperProps={{
                    sx: {
                      mt: 0.5,
                      backgroundColor: "#00acd6",
                      borderRadius: "8px",
                      overflow: "hidden",
                      minWidth: 200,
                      boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                      p: 0.5,
                    },
                  }}
                >
                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick(
                        "https://stxavierspune.akronsystems.com/MYDOCUMENT/pVIEWCIRCULAR.aspx"
                      )
                    }
                    sx={{
                      color: "white",
                      fontSize: "0.85rem",
                      borderRadius: "6px",
                      my: 0.3,
                      transition: "background-color 0.2s",
                      ":hover": {
                        backgroundColor: "#00c0ef",
                      },
                    }}
                  >
                    General Circulars
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick("https://stxavierspune.akronsystems.com/pLogin.aspx")
                    }
                    sx={{
                      color: "white",
                      fontSize: "0.85rem",
                      borderRadius: "6px",
                      my: 0.3,
                      transition: "background-color 0.2s",
                      ":hover": {
                        backgroundColor: "#00c0ef",
                      },
                    }}
                  >
                    Circulars for Xavierites
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick("https://stxavierspune.akronsystems.com/pLogin.aspx")
                    }
                    sx={{
                      color: "white",
                      fontSize: "0.85rem",
                      borderRadius: "6px",
                      my: 0.3,
                      transition: "background-color 0.2s",
                      ":hover": {
                        backgroundColor: "#00c0ef",
                      },
                    }}
                  >
                    Circulars for Staff
                  </MenuItem>
                </Menu>
              </Box>


              <Link
                href="https://stxavierspune.akronsystems.com/Admission/pADMISSIONNEW.aspx"
                underline="none"
                color="inherit"
                target="_blank"
                sx={{
                  fontSize: "0.8rem",
                  color: "white",
                  backgroundColor: "#00acd6",
                  px: 1,
                  py: 0.5,
                  borderRadius: "4px",
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%": { transform: "scale(1)" },
                    "50%": { transform: "scale(1.15)" },
                    "100%": { transform: "scale(1)" },
                  },
                  ":hover": {
                    backgroundColor: "#00c0ef",
                  },
                }}
              >
                Admission Form 2027–2028
              </Link>


              <Link
                href="https://stxavierspune.akronsystems.com/pLogin.aspx"
                underline="none"
                color="inherit"
                target="_blank"
                sx={{
                  fontSize: "0.8rem",
                  color: "white",
                  backgroundColor: "#00acd6",
                  px: 1,
                  py: 0.5,
                  borderRadius: "4px",
                  ":hover": {
                    backgroundColor: "#00c0ef",
                  },
                }}
              >
                ERP Login
              </Link>


              <IconButton
                sx={{
                  fontSize: "1rem",
                  padding: "5px !important",
                  color: "white",
                  backgroundColor: "customColors.clr2",
                  ":hover": {
                    backgroundColor: "#FF0000",
                    color: "white",
                  },
                }}
                component={motion.div}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{
                  opacity: 1,
                  scale: 1,
                  transition: {
                    duration: 0.1,
                    ease: [0, 0.71, 0.2, 1.01],
                    scale: {
                      type: "spring",
                      damping: 5,
                      stiffness: 100,
                      restDelta: 0.001,
                    },
                  },
                }}
              >
                <YouTubeIcon fontSize="small" />
              </IconButton>
              <IconButton
                sx={{
                  fontSize: "1rem",
                  padding: "5px !important",
                  color: "white",
                  backgroundColor: "customColors.clr2",
                  ":hover": {
                    backgroundColor: "#4267B2",
                    color: "white",
                  },
                }}
                component={motion.div}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{
                  opacity: 1,
                  scale: 1,
                  transition: {
                    duration: 0.1,
                    ease: [0, 0.71, 0.2, 1.01],
                    scale: {
                      type: "spring",
                      damping: 5,
                      stiffness: 100,
                      restDelta: 0.001,
                    },
                  },
                }}
              >
                <FacebookOutlinedIcon fontSize="small" />
              </IconButton>
              <IconButton
                sx={{
                  fontSize: "1rem",
                  padding: "5px !important",
                  color: "white",
                  backgroundColor: "customColors.clr2",
                  "&:hover": {
                    background:
                      "linear-gradient(to right, #f9ce34, #ee2a7b, #6228d7)",
                    color: "white",
                  },
                }}
                component={motion.div}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{
                  opacity: 1,
                  scale: 1,
                  transition: {
                    duration: 0.1,
                    ease: [0, 0.71, 0.2, 1.01],
                    scale: {
                      type: "spring",
                      damping: 5,
                      stiffness: 100,
                      restDelta: 0.001,
                    },
                  },
                }}
              >
                <InstagramIcon fontSize="small" />
              </IconButton>
            </Stack>
            <Grid
              container
              sx={{ width: "100%" }}
              alignItems={"center"}
              justifyContent={"flex-end"}
            >
              <Grid item alignSelf={"center"}>
                <Stack
                  flexDirection={"row"}
                  alignItems={"center"}
                  component={motion.div}
                  initial={{ scale: 0 }}
                  whileInView={{
                    scale: 1,
                    transition: { duration: 0.5, delay: 0.1 },
                  }}
                >
                  <MailIcon
                    sx={{
                      color: "customColors.clr1",
                      fontSize: isSmallScreen ? "0.8rem" : "1rem",
                    }}
                    fontSize="small"
                  />{" "}
                  <Link
                    href={`mailto:stxavierspune37@gmail.com`}
                    underline="hover"
                    sx={{ fontSize: isSmallScreen ? "0.5rem" : "0.8rem" }}
                  >
                    stxavierspune37@gmail.com
                  </Link>
                </Stack>
              </Grid>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Grid item>
                <Stack
                  flexDirection={"row"}
                  alignItems={"center"}
                  component={motion.div}
                  initial={{ scale: 0 }}
                  whileInView={{
                    scale: 1,
                    transition: { duration: 0.5, delay: 0.2 },
                  }}
                >
                  <PhoneIcon
                    sx={{
                      color: "customColors.clr1",
                      fontSize: isSmallScreen ? "0.8rem" : "1rem",
                    }}
                    fontSize="small"
                  />{" "}
                  <Link
                    href={`tel:+91 8149830102`}
                    underline="hover"
                    sx={{ fontSize: isSmallScreen ? "0.5rem" : "0.8rem" }}
                  >
                    +91 8149830102
                  </Link>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Stack>
      ) : (
        <Link
          href="https://stxavierspune.akronsystems.com/pLogin.aspx"
          underline="hover"
          color="inherit"
          target="_blank"
          sx={{
            fontSize: "0.8rem",
            color: "white",
            backgroundColor: "#00acd6",
            px: 1,
            py: 0.5,
            borderRadius: "4px",
            ":hover": {
              backgroundColor: "#00c0ef",
            },
          }}
        >
          ERP
        </Link>
      )}
    </Stack>
  );
};

export default Header;
